import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-02/lesson-13/task-02";

const task: Slide = {
  titleHtml: "HRTF changes with ...",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
